export const tableHeaders = [
  { label: 'name', sortable: true },
  { label: 'phone number', sortable: false },
  { label: 'email', sortable: false },
  { label: 'next pickup', sortable: true },
  { label: 'next mission', sortable: true },
  { label: 'missions booked <br> & ongoing', sortable: true },
  { label: 'flyer packs', sortable: true },
]

export const dateTimeFormat = 'D MMM YYYY, HH:mm'
